module.exports = __webpack_public_path__ + "img/italy-ischemic-heart-disease-male.b3b4745a.png";